import { BiLinkExternal } from "react-icons/bi";

const MEDIUM_URL = "https://medium.com/@adetifaboluwatife";

const MediumCard = () => (
  <a
    href={MEDIUM_URL}
    target="_blank"
    rel="noreferrer"
    className="group flex items-center justify-between border border-border rounded-lg p-6 max-w-xl hover:border-accent transition-colors"
  >
    <div>
      <p className="text-white font-semibold">Read on Medium</p>
      <p className="text-sm text-muted mt-1">@adetifaboluwatife</p>
    </div>
    <BiLinkExternal className="w-5 h-5 text-muted group-hover:text-accent transition-colors" />
  </a>
);

export default MediumCard;
